import { render } from "./Signup.vue?vue&type=template&id=ed53cb40&scoped=true&ts=true"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=ed53cb40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed53cb40"]])

export default __exports__